import { Drawer, Popover } from "@closer/ui";
import type { ReactNode } from "react";

import { useIsDesktop } from "../lib/useIsDesktop";

export interface TopBarPanelProps {
  open: boolean;
  onClose: () => void;
  /** Erişilebilir başlık — mobil drawer'da da kullanılıyor. */
  title: string;
  /** Paneli açan düğme. Görünürlüğü çağıran karar veriyor. */
  trigger: ReactNode;
  children: ReactNode;
}

/**
 * Üst Bar panellerinin ORTAK KABUĞU (CLOS-98 `[059]`).
 *
 * ### Neden burada
 *
 * `[060]` çalışma alanı seçici, `[061]` arama, `[063]` bekleyen işlemler, `[064]`
 * bildirimler ve `[065]` profil menüsü — beşi de aynı şeyi istiyor: masaüstünde
 * tetikleyiciye bağlı bir popover, mobilde tam yükseklikte bir drawer. Her kart kendi
 * kabuğunu yazsaydı kriter 5 beş kez ihlal edilir ve panel davranışı yerden yere
 * değişirdi.
 *
 * ### Mobilde drawer, masaüstünde popover
 *
 * Dar ekranda popover içeriği ekrana sığmıyor ve dokunmatik hedefleri küçük kalıyor.
 * Karar `useIsDesktop` ile tek noktadan veriliyor (`[058]` ile aynı kaynak) — CSS'le
 * gizlemek, gizli bir popover'ın odak davranışını canlı bırakırdı.
 *
 * ### ⚠ Panel kritik işlemi TAMAMLAMAZ
 *
 * Kartın mimari kısıtı: *"Üst Bar paneli kritik workflow işlemini kendi içinde
 * tamamlamaz; ilgili kayda yönlendirir."* Bu kabuk onay/ret/imza gibi bir aksiyon yüzeyi
 * SUNMUYOR — yalnız içerik ve yönlendirme taşıyor. Tüketen kartlar bu sınırı korumalı;
 * panele bir "Onayla" düğmesi koymak kartın kriterini çiğner.
 */
export function TopBarPanel({ open, onClose, title, trigger, children }: TopBarPanelProps) {
  const desktop = useIsDesktop();

  if (desktop) {
    return (
      <Popover open={open} onClose={onClose} trigger={trigger}>
        {children}
      </Popover>
    );
  }

  return (
    <>
      {trigger}
      <Drawer open={open} onClose={onClose} title={title} side="right" showTitle>
        {children}
      </Drawer>
    </>
  );
}
